module.exports = __webpack_public_path__ + "img/packs-badge.4abdb0e5.svg";